export const copyRight = '© Ellen MacArthur Foundation';

export const description =
  "La Fondation Ellen MacArthur travaille dans les domaines de l'éducation et de la formation, des entreprises et du gouvernement, de la perspicacité et de l'analyse, des initiatives systémiques et des communications pour accélérer la transition vers une économie circulaire.";

export const registrationNumbers = [
  "Numéro d'enregistrement d'organisme de bienfaisance: 1130306",
  "OSCR Numéro d'enregistrement: SC043120",
  "Numéro d'entreprise: 6897785",
  'Ellen MacArthur Foundation ANBI RSIN nummer: 8257 45 925',
];

export const primaryLinks = [
  {
    title: 'À propos de nous',
    url: `/fr/about-us`,
  },
  {
    title: 'Notre réseau',
    url: `/fr/standard/network/overview`,
  },
  {
    title: "Offres d'emploi",
    url: `/fr/jobs`,
  },
  {
    title: 'Nous contacter',
    url: `/fr/contact-us`,
  },
  {
    title: 'Salle de presse',
    url: `/fr/standard/media-centre/overview`,
  },
];

export const secondaryLinks = [
  // Optional - currently all links fit in one column
];

export const subContentLinks = [
  {
    title: 'Légal',
    url: '/legal',
  },
  {
    title: 'Intimité',
    url: '/intimite',
  },
  {
    title: 'Cookies',
    url: '/cookies',
  },
];

// @todo:  translate
export const partners = {
  text: 'The work of the Ellen MacArthur Foundation is supported by our ',
  linkText: 'Strategic Partners and Partners.',
  linkUrl: '/network/who-is-in-the-network',
};

export const socialLinks = [
  {
    type: 'linkedIn',
    alt: 'Link to EMF LinkedIn page. Opens in a new tab.',
    url: 'https://uk.linkedin.com/company/ellen-macarthur-foundation',
  },
  {
    type: 'youTube',
    alt: 'Link to EMF YouTube page. Opens in a new tab.',
    url: 'https://www.youtube.com/user/made2bemadeagain',
  },
  {
    type: 'instagram',
    alt: 'Link to EMF Instagram page. Opens in a new tab.',
    url: 'https://www.instagram.com/ellenmacarthurfoundation/',
  },
  {
    type: 'medium',
    alt: 'Link to EMF Medium page. Opens in a new tab.',
    url: 'https://medium.com/@circulareconomy',
  },
];

export const poweredByContentful = {
  text: 'Powered by Contentful',
  url: 'https://www.contentful.com/',
};
